import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MessageService } from 'primeng/api'

import { ApiLeaseService } from '@modules/private/lease/data/services/api/api-lease.service'

/**
 * Diálogo para asignar el activo REAL a un arrendamiento originado con activo
 * provisional (asset=null). Lo usa el tab Activos del detalle del lease; el host
 * lo abre vía `@ViewChild(...).open()`. Si el valor del activo difiere del
 * provisional cotizado muestra un aviso (la QP se recalcula al asignar).
 */
@Component({
  selector: 'app-assign-asset-dialog',
  templateUrl: './assign-asset-dialog.component.html',
})
export class AssignAssetDialogComponent {
  @Input() leaseId?: string
  /** Valor provisional cotizado (con IVA) — para avisar si el activo real difiere. */
  @Input() provisionalValue?: number | null
  /** Se emite tras una asignación exitosa para que el host refresque. */
  @Output() assigned = new EventEmitter<void>()

  visible = false
  saving = false
  loadingOptions = false
  options: { label: string, value: string, amount: number }[] = []
  selectedAssetId: string | null = null

  constructor(
    private readonly apiLease: ApiLeaseService,
    private readonly messageService: MessageService
  ) {}

  open(): void {
    this.selectedAssetId = null
    this.visible = true
    this.loadOptions()
  }

  get selectedAsset(): { label: string, value: string, amount: number } | null {
    return this.options.find((option) => option.value === this.selectedAssetId) ?? null
  }

  /** El valor del activo real difiere del provisional → los montos de la cotización se recalcularán. */
  get valueDiffers(): boolean {
    const selected = this.selectedAsset
    if (!selected || !this.provisionalValue) return false
    return Math.abs(selected.amount - this.provisionalValue) > 0.01
  }

  private loadOptions(): void {
    this.loadingOptions = true
    // Solo activos disponibles (status 'Activo'), mismo criterio que el catálogo del cotizador
    this.apiLease.fetchAssets({ page: 1, limit: 1000, filters: { status: { value: 'Activo', matchMode: 'equals' } } }).subscribe((options) => {
      this.options = options || []
      this.loadingOptions = false
    })
  }

  confirm(): void {
    if (!this.selectedAssetId || this.saving || !this.leaseId) return
    this.saving = true
    this.apiLease.assignAsset(this.leaseId, this.selectedAssetId).subscribe((r) => {
      this.saving = false
      if (r.error) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: r.msg, life: 5000 })
        return
      }
      this.messageService.add({ severity: 'success', summary: 'Activo asignado', detail: 'El activo real fue asignado al arrendamiento.', life: 4000 })
      this.visible = false
      this.assigned.emit()
    })
  }
}
